import { createElement, ElementType, lazy } from "react";
// TODO: Add lazy loading of each page element when development is complete

import Announcement from "../pages/admin/Announcement/Announcement";
import CustomAttendance from "../pages/admin/Attendance/CustomAttendance";
import CustomAttendanceDetails from "../pages/admin/Attendance/CustomAttendanceDetails";
import DailyAttendance from "../pages/admin/Attendance/DailyAttendance";
import ShiftManagement from "../pages/admin/Attendance/ShiftManagement";
import Dashboard from "../pages/admin/Dashboard/Dashboard";
import DevicesDetailsList from "../pages/admin/Devices/DevicesDetailsList";
import DevicesList from "../pages/admin/Devices/DevicesList";
import UnAllocateUserList from "../pages/admin/Devices/UnAllocateUserList";
import EmployeeDashboard from "../pages/admin/EmployeeDashboard/EmployeeDashboard";
import EditEmployees from "../pages/admin/Employees/EditEmployees";
import Employees from "../pages/admin/Employees/Employees";
import EmployeesDetails from "../pages/admin/Employees/EmployeesDetails";
import EmployeeTracking from "../pages/admin/EmployeeTracking/EmployeeTracking";
import EmployeeTrackingDetails from "../pages/admin/EmployeeTracking/EmployeeTrackingDetails";
import Expense from "../pages/admin/Expense/Expense";
import ExpenseDetails from "../pages/admin/Expense/ExpenseDetails";
import InterviewCall from "../pages/admin/JobPost/InterviewCall";
import InterviewList from "../pages/admin/JobPost/InterviewList";
import JobPost from "../pages/admin/JobPost/JobPost";
import ManageJob from "../pages/admin/JobPost/ManageJob";
import ViewJob from "../pages/admin/JobPost/ViewJob";
import AppraisalReport from "../pages/admin/KPISetup/AppraisalReport/AppraisalReport";
import AppraisalReportCreate from "../pages/admin/KPISetup/AppraisalReport/AppraisalReportCreate";
import KPISetupReport from "../pages/admin/KPISetup/KPISetupReport/KPISetupReport";
import KPISetupReportCreate from "../pages/admin/KPISetup/KPISetupReport/KPISetupReportCreate";
import OpenAppraisalSetup from "../pages/admin/KPISetup/OpenKPISetup/OpenAppraisalSetup";
import OpenKPISetup from "../pages/admin/KPISetup/OpenKPISetup/OpenKPISetup";
import OpenKPISetupCreate from "../pages/admin/KPISetup/OpenKPISetup/OpenKPISetupCreate";
import OwnAppraisals from "../pages/admin/KPISetup/OwnAppraisals/OwnAppraisals";
import OwnAppraisalsCreate from "../pages/admin/KPISetup/OwnAppraisals/OwnAppraisalsCreate";
import OwnKPI from "../pages/admin/KPISetup/OwnKPI/OwnKPI";
import OwnKPICreate from "../pages/admin/KPISetup/OwnKPI/OwnKPICreate";
import TeamMemberAppraisal from "../pages/admin/KPISetup/TeamMemberAppraisal/TeamMemberAppraisal";
import TeamMemberAppraisalCreate from "../pages/admin/KPISetup/TeamMemberAppraisal/TeamMemberAppraisalCreate";
import TeamMemberKPI from "../pages/admin/KPISetup/TeamMemberKPI/TeamMemberKPI";
import TeamMemberKPICreate from "../pages/admin/KPISetup/TeamMemberKPI/TeamMemberKPICreate";
import LeaveBalance from "../pages/admin/Leave/LeaveBalance";
import LeaveBalanceDetails from "../pages/admin/Leave/LeaveBalanceDetails";
import LeaveRequestDetails from "../pages/admin/Leave/LeaveRequestDetails";
import LeaveRequests from "../pages/admin/Leave/LeaveRequests";
import Notifications from "../pages/admin/Notifications/Notifications";
import AdditionDeductionsSalary from "../pages/admin/Payroll/AdditionDeductionsSalary";
import HolidayAllowance from "../pages/admin/Payroll/HolidayAllowance";
import OvertimeUpload from "../pages/admin/Payroll/OvertimeUpload";
import PayReport from "../pages/admin/Payroll/PayReport";
import PayrollDetails from "../pages/admin/Payroll/PayrollDetails";
import PayrollSummary from "../pages/admin/Payroll/PayrollSummary";
import TaxReport from "../pages/admin/Payroll/TaxReport";
import VariableSalary from "../pages/admin/Payroll/VariableSalary";
import PettyCash from "../pages/admin/PettyCash/PettyCash";
import Profile from "../pages/admin/Profile/Profile";
import Report from "../pages/admin/Report/Report";
import Approval from "../pages/admin/Settings/Approval/Approval";
import ConfigDeviceApiToken from "../pages/admin/Settings/ConfigDeviceApiToken/ConfigDeviceApiToken";
import Department from "../pages/admin/Settings/Department/Department";
import Designation from "../pages/admin/Settings/Designation/Designation";
import EmployeeCustomFields from "../pages/admin/Settings/EmployeeCustomFields/EmployeeCustomFields";
import LiveTracking from "../pages/admin/Settings/EmployeeTracking/LiveTracking";
import LiveTrackingChangeLog from "../pages/admin/Settings/EmployeeTracking/LiveTrackingChangeLog";
import VisitSettings from "../pages/admin/Settings/EmployeeTracking/VisitSettings";
import ExpenseUnit from "../pages/admin/Settings/ExpenseUnit/ExpenseUnit";
import Adjustment from "../pages/admin/Settings/Leave/Adjustment";
import LeaveProrate from "../pages/admin/Settings/Leave/LeaveProrate";
import LeaveProrateDetails from "../pages/admin/Settings/Leave/LeaveProrateDetails";
import LeaveProrateEmployee from "../pages/admin/Settings/Leave/LeaveProrateEmployee";
import LeaveType from "../pages/admin/Settings/Leave/LeaveType";
import Others from "../pages/admin/Settings/Leave/Others";
import Attendance from "../pages/admin/Settings/OfficeSettings/Attendance";
import ChangeLog from "../pages/admin/Settings/OfficeSettings/ChangeLog";
import Holiday from "../pages/admin/Settings/OfficeSettings/Holiday";
import OfficeSettingsLeave from "../pages/admin/Settings/OfficeSettings/Leave";
import NotificationSetting from "../pages/admin/Settings/OfficeSettings/NotificationSetting/NotificationSetting";
import Operational from "../pages/admin/Settings/OfficeSettings/Operational";
import Shift from "../pages/admin/Settings/OfficeSettings/Shift";
import PayComponents from "../pages/admin/Settings/Payroll/PayComponents";
import PaySchedule from "../pages/admin/Settings/Payroll/PaySchedule";
import SalaryBreakdown from "../pages/admin/Settings/Payroll/SalaryBreakdown";
import TaxSetting from "../pages/admin/Settings/Payroll/TaxSetting";
import WorkStation from "../pages/admin/Settings/WorkStation/WorkStation";
import SupportTickets from "../pages/admin/SupportTickets/SupportTickets";
import MySupportTickets from "../pages/admin/SupportTickets/MySupportTickets";
import TaskQueue from "../pages/admin/TaskQueue/TaskQueue";
import MyVisit from "../pages/admin/Visit/MyVisit";
import MyVisitDetails from "../pages/admin/Visit/MyVisitDetails";
import TeamVisit from "../pages/admin/Visit/TeamVisit";
import KeycloakSignIn from "../pages/auth/KeycloakSignIn";
import Performance from "../pages/employee/Performance/Performance";
import Promotion from "../pages/employee/Promotion/Promotion";
import { Role } from "../types/common";
const NotFound = lazy(() => import("../pages/NotFound"));
// const SignIn = lazy(() => import("../pages/auth/SignIn"));
const JobDetails = lazy(() => import("../pages/applicant/JobDetails"));
const SignUp = lazy(() => import("../pages/auth/SignUp"));
const ForgotPassword = lazy(() => import("../pages/auth/ForgotPassword"));
const ResetPassword = lazy(() => import("../pages/auth/ResetPassword"));
const VerifyAccount = lazy(() => import("../pages/auth/VerifyAccount"));
const UpdatePasswordForOldUser = lazy(
  () => import("../pages/auth/UpdatePasswordForOldUser")
);

export interface RouteType {
  path: string;
  element: ElementType;
  roles: Role[];
  name?: string;
}

// auth routers
export const sidebarRouters: RouteType[] = [
  {
    path: "/admin/dashboard",
    element: Dashboard,
    roles: ["Admin", "Manager"],
  },
  // employees
  {
    path: "/admin/employees",
    element: Employees,
    roles: ["Admin", "Manager"],
  },
  {
    path: "/admin/employees/view/:viewId",
    element: EmployeesDetails,
    roles: ["Admin", "Manager"],
  },

  {
    path: "/admin/employees/edit/:editId",
    element: EditEmployees,
    roles: ["Admin"],
  },
  // Device
  {
    path: "/admin/devices",
    element: DevicesList,
    roles: ["Admin"],
  },
  {
    path: "/admin/devices/view/:viewId",
    element: DevicesDetailsList,
    roles: ["Admin"],
  },
  {
    path: "/admin/devices/un-allocate/view/:viewId",
    element: UnAllocateUserList,
    roles: ["Admin"],
  },

  // Leave
  {
    path: "/admin/leave/leave-requests",
    element: LeaveRequests,
    roles: ["Admin", "Manager"],
  },
  {
    path: "/admin/leave/leave-requests/view/:viewId",
    element: LeaveRequestDetails,
    roles: ["Admin", "Manager"],
  },
  {
    path: "/admin/leave/leave-balance",
    element: LeaveBalance,
    roles: ["Admin", "Manager"],
  },
  {
    path: "/admin/leave/leave-balance/view/:viewId",
    element: LeaveBalanceDetails,
    roles: ["Admin", "Manager"],
  },

  // Attendance
  {
    path: "/admin/attendance/daily-attendance",
    element: DailyAttendance,
    roles: ["Admin", "Manager"],
  },
  {
    path: "/admin/attendance/custom-attendance",
    element: CustomAttendance,
    roles: ["Admin", "Manager"],
  },
  {
    path: "/admin/attendance/custom-attendance/view/:viewId",
    element: CustomAttendanceDetails,
    roles: ["Admin", "Manager"],
  },
  {
    path: "/admin/attendance/shift-management",
    element: ShiftManagement,
    roles: ["Admin", "Manager"],
  },
  // expense
  {
    path: "/admin/expense",
    element: Expense,
    roles: ["Admin", "Manager"],
  },
  {
    path: "/admin/expense/view/:viewId",
    element: ExpenseDetails,
    roles: ["Admin", "Manager"],
  },
  // visit
  {
    path: "/admin/visit",
    element: MyVisit,
    roles: ["Admin"],
  },
  {
    path: "/admin/visit/view/:viewId",
    element: MyVisitDetails,
    roles: ["Admin"],
  },
  {
    path: "/admin/visit/team-visit",
    element: TeamVisit,
    roles: ["Admin"],
  },
  {
    path: "/admin/visit/team-visit/view/:viewId",
    element: MyVisitDetails,
    // element: TeamVisitDetails,
    roles: ["Admin"],
  },
  // employee tracking
  {
    path: "/admin/employee-tracking",
    element: EmployeeTracking,
    roles: ["Admin"],
  },
  {
    path: "/admin/employee-tracking/view/:viewId",
    element: EmployeeTrackingDetails,
    roles: ["Admin"],
  },
  // Settings
  {
    path: "/admin/settings/approval",
    element: Approval,
    roles: ["Admin"],
  },

  {
    path: "/admin/settings/office-settings",
    element: Operational,
    roles: ["Admin"],
  },
  {
    path: "/admin/settings/office-settings/attendance",
    element: Attendance,
    roles: ["Admin"],
  },
  {
    path: "/admin/settings/office-settings/shift",
    element: Shift,
    roles: ["Admin"],
  },
  {
    path: "/admin/settings/office-settings/leave",
    element: OfficeSettingsLeave,
    roles: ["Admin"],
  },
  {
    path: "/admin/settings/leave",
    element: LeaveType,
    roles: ["Admin"],
  },
  {
    path: "/admin/settings/leave/leave-prorate",
    element: LeaveProrate,
    roles: ["Admin"],
  },
  {
    path: "/admin/settings/leave/leave-prorate/view/:viewId",
    element: LeaveProrateEmployee,
    roles: ["Admin"],
  },
  {
    path: "/admin/settings/leave/leave-prorate/:viewId/:detailsId",
    element: LeaveProrateDetails,
    roles: ["Admin"],
  },
  {
    path: "/admin/settings/leave/adjustment",
    element: Adjustment,
    roles: ["Admin"],
  },
  {
    path: "/admin/settings/leave/others",
    element: Others,
    roles: ["Admin"],
  },
  {
    path: "/admin/settings/office-settings/holiday",
    element: Holiday,
    roles: ["Admin"],
  },
  {
    path: "/admin/settings/office-settings/notification",
    element: NotificationSetting,
    roles: ["Admin"],
  },
  {
    path: "/admin/settings/office-settings/change-log",
    element: ChangeLog,
    roles: ["Admin"],
  },
  {
    path: "/admin/settings/department",
    element: Department,
    roles: ["Admin"],
  },
  {
    path: "/admin/settings/work-station",
    element: WorkStation,
    roles: ["Admin"],
  },
  {
    path: "/admin/settings/expense-unit",
    element: ExpenseUnit,
    roles: ["Admin"],
  },
  {
    path: "/admin/settings/designation",
    element: Designation,
    roles: ["Admin"],
  },
  {
    path: "/admin/settings/config-device-api-token",
    element: ConfigDeviceApiToken,
    roles: ["Admin"],
  },

  {
    path: "/admin/settings/employee-custom-fields",
    element: EmployeeCustomFields,
    roles: ["Admin"],
  },
  {
    path: "/admin/settings/visit-settings",
    element: VisitSettings,
    roles: ["Admin"],
  },
  {
    path: "/admin/settings/employee-tracking",
    element: LiveTracking,
    roles: ["Admin", "Manager"],
  },
  {
    path: "/admin/settings/employee-tracking/live-tracking-change-log",
    element: LiveTrackingChangeLog,
    roles: ["Admin"],
  },

  {
    path: "/admin/petty-cash",
    element: PettyCash,
    roles: ["Admin"],
  },
  //Announcement
  {
    path: "/admin/announcement",
    element: Announcement,
    roles: ["Admin", "Manager"],
  },

  // support tickets
  {
    path: "/admin/support-tickets",
    element: SupportTickets,
    roles: ["Admin"],
  },
  {
    path: "/admin/recruitment/job-post",
    element: JobPost,
    roles: ["Admin"],
  },
  {
    path: "/admin/recruitment/job-post/add",
    element: ManageJob,
    roles: ["Admin"],
  },
  {
    path: "/admin/recruitment/job-post/update/:id",
    element: ManageJob,
    roles: ["Admin"],
  },
  {
    path: "/admin/recruitment/job-post/view/:id",
    element: ViewJob,
    roles: ["Admin"],
  },
  {
    path: "/admin/recruitment/interview-list",
    element: InterviewList,
    roles: ["Admin"],
  },
  {
    path: "/admin/recruitment/interview-list/add",
    element: InterviewCall,
    roles: ["Admin"],
  },

  // payroll
  {
    path: "/admin/payroll",
    element: PayrollSummary,
    roles: ["Admin"],
  },
  {
    path: "/admin/payroll/pay-report",
    element: PayReport,
    roles: ["Admin"],
  },
  {
    path: "/admin/payroll/pay-report/view/:id",
    element: PayReport,
    roles: ["Admin"],
  },
  {
    path: "/admin/payroll/pay-report/:id/:detailsId",
    element: PayrollDetails,
    roles: ["Admin"],
  },
  {
    path: "/admin/payroll/tax-report",
    element: TaxReport,
    roles: ["Admin"],
  },
  {
    path: "/admin/payroll/variable-salary",
    element: VariableSalary,
    roles: ["Admin", "Manager"],
  },
  {
    path: "/admin/payroll/addition-deductions-salary",
    element: AdditionDeductionsSalary,
    roles: ["Admin", "Manager"],
  },
  {
    path: "/admin/payroll/overtime-salary",
    element: OvertimeUpload,
    roles: ["Admin", "Manager"],
  },
  {
    path: "/admin/payroll/holiday-allowance",
    element: HolidayAllowance,
    roles: ["Admin", "Manager"],
  },

  // payroll setting
  {
    path: "/admin/settings/payroll",
    element: SalaryBreakdown,
    roles: ["Admin"],
  },
  {
    path: "/admin/settings/payroll/pay-components",
    element: PayComponents,
    roles: ["Admin"],
  },
  {
    path: "/admin/settings/payroll/pay-schedule",
    element: PaySchedule,
    roles: ["Admin"],
  },
  {
    path: "/admin/settings/payroll/tax-setting",
    element: TaxSetting,
    roles: ["Admin"],
  },
  // profile
  {
    path: "/admin/profile",
    element: Profile,
    roles: ["Admin"],
  },

  {
    path: "/admin/reports",
    element: Report,
    roles: ["Admin", "Manager"],
  },
  {
    path: "/admin/task-queue",
    element: TaskQueue,
    roles: ["Admin"],
  },

  {
    path: "/admin/task-queue",
    element: TaskQueue,
    roles: ["Admin"],
  },

  // Notifications
  {
    path: "/admin/notification",
    element: Notifications,
    roles: ["Admin"],
  },
  {
    path: "/verify-account",
    element: VerifyAccount,
    roles: ["Admin", "Manager", "Employee"],
  },
  {
    path: "/admin/promotion",
    element: Promotion,
    roles: ["Manager", "Employee"],
  },
  {
    path: "/admin/performance-management",
    element: Performance,
    roles: ["Manager", "Employee"],
  },
  {
    path: "/admin/kpi-setup/open-kpi-setup",
    element: OpenKPISetup,
    roles: ["Admin"],
  },
  {
    path: "/admin/kpi-setup/open-kpi-setup/create",
    element: OpenKPISetupCreate,
    roles: ["Admin"],
  },
  {
    path: "/admin/kpi-setup/open-kpi-setup/view/:viewId",
    element: OpenKPISetupCreate,
    roles: ["Admin"],
  },
  {
    path: "/admin/kpi-setup/open-kpi-setup/update/:id",
    element: OpenKPISetupCreate,
    roles: ["Admin"],
  },
  {
    path: "/admin/kpi-setup/open-kpi-setup/open-appraisal-setup/:id",
    element: OpenAppraisalSetup,
    roles: ["Admin"],
  },
  {
    path: "/admin/kpi-setup/kpi-setup-report",
    element: KPISetupReport,
    roles: ["Admin"],
  },
  {
    path: "/admin/kpi-setup/kpi-setup-report/view/:id",
    element: KPISetupReportCreate,
    roles: ["Admin"],
  },
  {
    path: "/admin/kpi-setup/appraisal-report",
    element: AppraisalReport,
    roles: ["Admin"],
  },
  {
    path: "/admin/kpi-setup/appraisal-report/view/:id",
    element: AppraisalReportCreate,
    roles: ["Admin"],
  },
  {
    path: "/admin/kpi-setup/own-kpi",
    element: OwnKPI,
    roles: ["Manager", "Employee"],
  },
  {
    path: "/admin/kpi-setup/own-kpi/create/:kpiId",
    element: OwnKPICreate,
    roles: ["Manager", "Employee"],
  },
  {
    path: "/admin/kpi-setup/own-kpi/view/:id",
    element: () => createElement(TeamMemberKPICreate, { type: "own" }),
    roles: ["Manager", "Employee"],
  },
  {
    path: "/admin/kpi-setup/own-appraisals",
    element: OwnAppraisals,
    roles: ["Manager", "Employee"],
  },
  {
    path: "/admin/kpi-setup/own-appraisals/view/:id",
    element: OwnAppraisalsCreate,
    roles: ["Manager", "Employee"],
  },
  {
    path: "/admin/kpi-setup/team-member-kpi",
    element: TeamMemberKPI,
    roles: ["Manager"],
  },
  {
    path: "/admin/kpi-setup/team-member-kpi/view/:id",
    element: TeamMemberKPICreate,
    roles: ["Manager"],
  },
  {
    path: "/admin/kpi-setup/team-member-appraisal",
    element: TeamMemberAppraisal,
    roles: ["Manager"],
  },
  {
    path: "/admin/kpi-setup/team-member-appraisal/view/:id",
    element: TeamMemberAppraisalCreate,
    roles: ["Manager"],
  },
  {
    path: "/admin/user-dashboard",
    element: EmployeeDashboard,
    roles: ["Manager", "Employee"],
  },
  {
    path: "/admin/my-support-tickets",
    element: MySupportTickets,
    roles: ["Manager", "Employee"],
  },
];

// public routers
export const publicRouters: Omit<RouteType, "roles">[] = [
  // {
  //   path: "/sign-in",
  //   element: SignIn,
  // },
  {
    path: "/sign-in",
    element: KeycloakSignIn,
  },
  {
    path: "/sign-up",
    element: SignUp,
  },
  {
    path: "/forgot-password",
    element: ForgotPassword,
  },
  {
    path: "/reset-password",
    element: ResetPassword,
  },
  {
    path: "/update-password",
    element: UpdatePasswordForOldUser,
  },
  {
    path: "/job-post/:id",
    element: JobDetails,
  },
  {
    path: "/404",
    element: NotFound,
  },
  {
    path: "*",
    element: NotFound,
  },
];
